// extracted by mini-css-extract-plugin
export var avatar = "_mk-3";
export var avatarContainer = "_mk-2";
export var avatarSpacer = "_mk-5";
export var avatarSpacerContainer = "_mk-4";
export var avatarStackContainer = "_mk-1";
export var bubble = "_mk-0";
export var remainderBubble = "_mk-6";